module.exports = __webpack_public_path__ + "img/SINGLE EAR RING PURPLE.ed36db2.svg";